const version = '1.28.1';

const commitId = '7f964a51';

const buildDate = '2024-10-18T13:11:17Z';

const buildUser = 'kamer';

const meta = {
    version,
    commitId,
    buildDate,
    buildUser
};

Object.freeze(meta);
Object.seal(meta);

console.log('Grispi UI build metadata', meta);

export { meta };
